// src/client/hooks/tours/useGetAgentTours.js
import { getAgentTours } from "@/client/services/tours/getAgentTours";
import { useApiQuery } from "@/shared/hooks/useApiQuery";

export const useGetAgentTours = ({ auth0UserId, accessToken, tourStatus = "scheduled", enabled = true }) => {
	return useApiQuery({
		queryKey: ["agentTours", auth0UserId, tourStatus],
		queryFn: () => getAgentTours({ auth0UserId, accessToken, tourStatus }),
		accessToken,
		auth0UserId,
		enabled: enabled && !!accessToken && !!auth0UserId,
		staleTime: 0,
	});
};
